import styled from 'styled-components';

export const ButtonsWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 9;
  width: 100%;
  margin: 0 auto;
`;
